import React from "react";
import styled from 'styled-components';
import PropTypes from "prop-types";

const Wrapper = styled.div`
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: all 0.15s ease-in;
  &:hover {

  }
`

const MySVG = styled.svg`
  path {
    fill: ${props => props.theme.colors.lightGrey};
    transition: all 1s ease-out;
  }
  &:hover {
    path {
      fill: ${props => props.theme.colors.blue};
    }
  }
`

const ReloadIcon = ({ onClick }) => (
  <Wrapper onClick={onClick}>
    <MySVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      x="0px"
      y="0px"
    >
      <path d="M50.1,18.11h-.5V12.88a4,4,0,0,0-6.5-3.12L27.39,22.32a4,4,0,0,0,0,6.25L43.1,41.14A4,4,0,0,0,49.6,38V32.78h.5A24,24,0,1,1,26.21,59a4,4,0,0,0-4-3.63H15.54a4,4,0,0,0-4,4.3A38.66,38.66,0,1,0,50.1,18.11Z" />
    </MySVG>
  </Wrapper>
);

ReloadIcon.PropTypes = {
  onClick: PropTypes.func.isRequired
}

export default ReloadIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/ReloadIcon.js